import { twMerge } from 'tailwind-merge'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'
import { useAppSelector } from '@/store/hooks'
import { CohortsModel } from '@models'
import Icon from '@/components/atoms/Icon'

dayjs.extend(utc)
dayjs.locale('pt-br')

interface CardMatriculateProps {
	course: CohortsModel.CohortCard
	className?: string
	onClick?: () => void
}

export function CardMatriculate({
	course,
	className,
	onClick,
}: CardMatriculateProps) {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const findOnboarding = user?.onboarding_all?.find(
		(onboading) => onboading.curso_id === course?.id
	)

	return (
		<div
			className={twMerge(
				className,
				'relative overflow-clip w-full h-[386px] flex-1 bg-[#2D1E3E] rounded-[10px] flex flex-col border border-white/10 cursor-pointer group hover:border-brand-primary'
			)}
			onClick={onClick}
		>
			{(() => {
				if (
					course &&
					course['type-course'] &&
					['AO VIVO'].includes(course['type-course'].toUpperCase()) &&
					findOnboarding?.nivel_onboarding === 4 &&
					user?.curso_interesse_id === findOnboarding?.curso_id
				) {
					return (
						<span className='bg-[#0B042599] absolute z-20 rounded-full px-2 text-white text-sm font-semibold top-4 left-4'>
							Aguardando liberação de turma
						</span>
					)
				}

				return <></>
			})()}

			<div className='absolute w-full h-full z-0'>
				<img
					src={course.capa_card}
					width='100%'
					height='100%'
					alt='Imagem do card de curso'
					className='absolute inset-0 w-full h-full top-0 bottom-0 object-fill'
				/>
			</div>

			<div className='flex w-9 h-9 items-center justify-center rounded-full bg-brand-primary opacity-0 absolute bottom-4 right-4 z-50 group-hover:opacity-100 duration-200'>
				<Icon
					name='arrow-top-hover-new'
					width='24px'
					height='24px'
					className='text-brand-primary'
				/>
			</div>
		</div>
	)
}
